module.exports = __webpack_public_path__ + "static/media/ic-gas.d9a65da4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/ic-gas.svg
// module id = 432
// module chunks = 0